import React, { Component } from "react";
import { Menu } from "antd";
import { queryApprovalUserCached } from '../../common/permissionCache';

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        const { selectKey } = props;
        this.state = {
            current: selectKey,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    componentDidMount() {
        this.queryApprovalUser();
    }

    // 查询财务管理权限
    queryApprovalUser = () => {
        queryApprovalUserCached('FIN_MODULE,TEACH_LEADER', res => {
            this.setState({
                menuAuth:res
            });
        });
    }

    render () {
        const { current,menuAuth={} } = this.state;
        const { INV_ABNORMAL_ROLE,INV_ABNORMAL_USER,isInvAreaLeader, FIN_MODULE, isSeniorUserBo, isLineCharge, FINANCE_INCOME_REPORT_USER, 
            isDesignatedTal, FINANCE_ADVANCE_PAYMENT, FINANCE_ORDER_IN_HAND_CHANGE, FINANCE_INV_ABNORMAL, FINANCE_SITE_INCOME, areaChargeUser } = menuAuth;
        const { curRole,curEmployeeCode,positionName } = sessionStorage;
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const isBO = curRole == 'BO';
        const isVP = curRole == 'VP';
        const isHRRC = curRole == 'HRRC';
        const isCRCC = curRole == 'CRCC';
        const isCRCM = curRole == 'CRCM';
        const isAssistantDirBo = curRole == 'BO' && (positionName == '助理主任' || positionName == '助理总监');
        const showFinance = !(isVP || isFIN || isPML || isInvAreaLeader || isHRRC ) ? (FIN_MODULE || []).some(i => i == curEmployeeCode) : true;
        const showFinancialAnomalyReport = ((INV_ABNORMAL_ROLE&&INV_ABNORMAL_ROLE.includes(curRole)==true)
        ||(INV_ABNORMAL_USER&&INV_ABNORMAL_USER.includes(curEmployeeCode)==true));
        
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe7e4;</i><span>财务管理</span></span>}>
                        {
                            (isFIN || isSeniorUserBo || isLineCharge || FINANCE_INCOME_REPORT_USER || isDesignatedTal) && <Menu.Item key="financeIncomeReport">
                            <a href="#/financeManagement/financeIncomeReport">财务收入报告</a>
                        </Menu.Item>
                        }
                        {
                            (isFIN || FINANCE_ADVANCE_PAYMENT) && <Menu.Item key="otherChargesReport">
                            <a href="#/financeManagement/otherChargesReport">代垫费用收入报告</a>
                        </Menu.Item>
                        }
                        {
                            (isFIN || isSeniorUserBo || FINANCE_ORDER_IN_HAND_CHANGE || isDesignatedTal) && <Menu.Item key="orderChangeReport">
                            <a href="#/financeManagement/orderChangeReport">在手订单额变动报告</a>
                        </Menu.Item>
                        }
                        {(isFIN || isSeniorUserBo || FINANCE_INV_ABNORMAL || isDesignatedTal)&&
                        <Menu.Item key="financialAnomalyReport">
                            <a href="#/financeManagement/financialAnomalyReport">服务费收入异常报告</a>
                        </Menu.Item>
                        }
                        {(isFIN || isCRCC || isCRCM || isSeniorUserBo || FINANCE_SITE_INCOME || isDesignatedTal || isLineCharge || areaChargeUser || isAssistantDirBo) &&
                            <Menu.Item key="centerIncomeReport">
                            <a href="#/financeManagement/centerIncomeReport">中心收入报告</a>
                        </Menu.Item>
                        }
                        {  isFIN && 
                            <Menu.Item key="collectReport">
                            <a href="#/financeManagement/collectReport">应收账款表</a>
                        </Menu.Item>
                        }
                        {   (isFIN || isBO || isHRRC || isCRCC || isCRCM ) && 
                            <Menu.Item key="IncomeReport">
                                <a href="#/financeManagement/IncomeReport">个人收入报告</a>
                            </Menu.Item>
                        }
                        {  isFIN &&
                            <Menu.Item key="incomestatement">
                                <a href="#/financeManagement/incomestatement">收入报表</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;


// WEBPACK FOOTER //
// ./src/components/financeManagement/SideNav.js